module.exports = __webpack_public_path__ + "img/rouge3_noir.7abc88d6.webp";